import { Component } from '@angular/core';
import { Product, ProductScope } from '@spartacus/core';
import { CurrentProductService, ProductSummaryComponent } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { NgIf, NgFor, AsyncPipe } from '@angular/common';

@Component({
    selector: 'knbr-kn-br-key-feature-components',
    templateUrl: './kn-br-key-feature-components.component.html',
    styleUrls: ['./kn-br-key-feature-components.component.scss'],
    imports: [NgIf, NgFor, AsyncPipe]
})
export class KnBrKeyFeatureComponentsComponent  {

     product$: Observable<Product | null> = this.service
          .getProduct([ProductScope.DETAILS])
        constructor(
          protected service: CurrentProductService    
        ){}
}
